/**
 * Features Category Banner
 *
 * Simple radar/monitoring illustration representing app capabilities.
 * Designed as a standalone icon to accompany text in a merged header.
 */

import type { CategoryBannerProps } from './index';

export function FeaturesBanner({
  width = 100,
  height = 100,
  className = '',
}: CategoryBannerProps) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Features category illustration"
      style={{ maxWidth: '100%', height: 'auto' }}
    >
      <defs>
        <linearGradient id="featuresRadar" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#9d8de5" />
          <stop offset="100%" stopColor="#8b7bd8" />
        </linearGradient>
      </defs>

      {/* Subtle background circle */}
      <circle cx="50" cy="50" r="46" fill="#f5f3fb" />

      {/* Radar rings */}
      <circle cx="50" cy="50" r="30" fill="none" stroke="#d4ccf0" strokeWidth="2" />
      <circle cx="50" cy="50" r="20" fill="none" stroke="#d4ccf0" strokeWidth="2" />
      <circle cx="50" cy="50" r="10" fill="none" stroke="#d4ccf0" strokeWidth="2" />

      {/* Crosshairs */}
      <line x1="50" y1="18" x2="50" y2="82" stroke="#d4ccf0" strokeWidth="1.5" />
      <line x1="18" y1="50" x2="82" y2="50" stroke="#d4ccf0" strokeWidth="1.5" />

      {/* Radar sweep line */}
      <line x1="50" y1="50" x2="74" y2="32" stroke="url(#featuresRadar)" strokeWidth="3" strokeLinecap="round" />

      {/* Center dot */}
      <circle cx="50" cy="50" r="4" fill="url(#featuresRadar)" />

      {/* Detected points */}
      <circle cx="62" cy="38" r="5" fill="#f97316" />
      <circle cx="38" cy="58" r="4" fill="url(#featuresRadar)" />
    </svg>
  );
}
